import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Form } from 'react-bootstrap';
import { ToggleSwitch } from '../common';

const WebTrackingApproval = ({
  isEnabledWebTracking,
  UpdateWebTrackingApproval,
}) => (
  <Formik
    initialValues={{
      excludeInvitationProcess: isEnabledWebTracking,
    }}
    enableReinitialize
    validationSchema={Yup.object({
      isWebTrackingApprovalEnabled: Yup.boolean(),
    })}
    onSubmit={(values) => {
      UpdateWebTrackingApproval(values);
    }}
  >
    {(formikprops) => (
      <div className="col-12 col-md-12">
        <Form onSubmit={formikprops.handleSubmit} className="needs-validation">
          <Row>
            <Col>
              <h4 className="font-weight-base mb-1">Web tracking</h4>
              <small className="text-muted">
                Web tracking feature allows time tracking directly from the web
                app, including the tracking page and the timer on the top
                header.
              </small>
            </Col>
            <Col className="col-auto">
              <ToggleSwitch
                id="excludeInvitationProcess"
                name="excludeInvitationProcess"
                handleChangeforChecked={UpdateWebTrackingApproval}
                checked={isEnabledWebTracking}
              />
            </Col>
          </Row>
        </Form>
      </div>
    )}
  </Formik>
);
WebTrackingApproval.propTypes = {
  isEnabledWebTracking: PropTypes.bool,
  UpdateWebTrackingApproval: PropTypes.func,
};
export default WebTrackingApproval;
